import { useNavigate } from "react-router-dom";
import BrandMarks from "../components/BrandMarks";
import exxonLogo from "../assets/exxonmobil-logo.png";
import daewooLogo from "../assets/daewoo-logo.png";
import jgcLogo from "../assets/jgc-logo.png";
import hyundaiLogo from "../assets/hyundai-ec-logo.png";
import projectCarrierLogo from "../assets/project-carrier-logo.png";

const AUDIENCE_CARDS = [
  { ic: "🛂", title: "Employment Visa Request", desc: "Already have an offer or assignment on the Papua LNG Project? Start your work permit and visa request here.", to: "/apply/visa" },
  { ic: "🧰", title: "Job Seekers", desc: "Register your interest and upload your CV and certificates for roles on the Papua LNG Project.", to: "/apply/jobs" },
  { ic: "🏢", title: "Korean Companies — Subcontracts", desc: "Submit your company profile and documents for subcontracting opportunities in the upstream and midstream logistics chain.", to: "/apply/company" },
  { ic: "🌏", title: "General Business Interest", desc: "Interested in other Papua New Guinea projects and opportunities? Let us know what you're looking for.", to: "/apply/general" },
];

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <>
      <section className="hero">
        <div className="hero-content">
          <div className="hero-marks"><BrandMarks size={92}/></div>
          <div className="hero-inc">Papua LNG Project · Republic of Korea</div>
          <h1>Korea <em>Papua LNG</em></h1>
          <div className="hero-sub">Korean Workforce &amp; Business Portal</div>
          <p>
            The bridge between Korean contractors, workers and companies and the
            Papua LNG Project's upstream EPC contractor, Daewoo E&amp;C, and the
            Korean-led logistics chain supporting it. Established by a group of
            Koreans and Papua LNG landowners to make labour law, work permits,
            visas, recruitment and business opportunities easier to navigate.
          </p>
          <div className="hero-btns">
            <button className="h-b1" onClick={() => navigate("/apply")}>Get Started →</button>
            <button className="h-b2" onClick={() => navigate("/about")}>About the Project</button>
          </div>
        </div>
      </section>

      <div className="badge-bar">
        <div className="badge">
          <div className="badge-ic badge-ic-logo"><img src={exxonLogo} alt="ExxonMobil logo"/></div>
          <div><div className="badge-lbl">Operator</div><div className="badge-val">ExxonMobil</div></div>
        </div>
        <div className="badge">
          <div className="badge-ic badge-ic-logo"><img src={daewooLogo} alt="Daewoo E&C logo"/></div>
          <div><div className="badge-lbl">Upstream EPC</div><div className="badge-val">Daewoo E&amp;C</div></div>
        </div>
        <div className="badge">
          <div className="badge-ic badge-ic-logo badge-ic-jv">
            <img src={jgcLogo} alt="JGC logo"/>
            <span className="jv-plus">+</span>
            <img src={hyundaiLogo} alt="Hyundai Engineering & Construction logo"/>
          </div>
          <div><div className="badge-lbl">Downstream EPC</div><div className="badge-val">JGC + Hyundai E&amp;C</div></div>
        </div>
        <div className="badge">
          <div className="badge-ic badge-ic-logo badge-ic-wide"><img src={projectCarrierLogo} alt="Project Carrier Korea logo"/></div>
          <div><div className="badge-lbl">Korean Logistics</div><div className="badge-val">Project Carrier Korea</div></div>
        </div>
      </div>

      <section className="sec">
        <div className="container">
          <div className="sec-hdr">
            <div className="eyebrow">Who This Portal Serves</div>
            <h2>Four ways to get involved</h2>
            <p>Whether you're an individual worker or a company, choose the path that matches you.</p>
          </div>
          <div className="grid3">
            {AUDIENCE_CARDS.map(c => (
              <button key={c.to} className="card" onClick={() => navigate(c.to)}>
                <div className="card-body">
                  <div className="card-ic">{c.ic}</div>
                  <h3>{c.title}</h3>
                  <p>{c.desc}</p>
                  <div className="card-more">Start now →</div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="sec sec-alt">
        <div className="container">
          <div className="grid2">
            <div className="mv-g">
              <div className="mv-icon">🤝</div>
              <div className="mv-title">Why Korea Papua LNG</div>
              <div className="mv-text">
                As Daewoo E&amp;C and the Korean logistics chain mobilise for the
                Papua LNG Project's upstream construction, thousands of Korean
                workers and dozens of Korean companies will need clear,
                trustworthy guidance on labour law, work permits, visas and
                subcontracting — in one place, in Korean and English.
              </div>
            </div>
            <div className="mv-b">
              <div className="mv-icon">🇵🇬</div>
              <div className="mv-title">A Papua New Guinea Partnership</div>
              <div className="mv-text">
                This portal is established jointly by a group of Koreans and
                Papua LNG landowners — connecting the Korean workforce and
                supply chain with the local communities and businesses of the
                Papua LNG Project area.
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
